exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat[data-v-553e1870]{max-height:350px}", ""]);

// exports
